import { NgTemplateOutlet } from '@angular/common';
import { Component, TemplateRef, computed, contentChild, input, output } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatTab, MatTabContent, MatTabGroup, MatTabLabel } from '@angular/material/tabs';

@Component({
  selector: 'vectronic-details-layout',
  templateUrl: './details-layout.component.html',
  styleUrl: './details-layout.component.scss',
  imports: [MatIcon, MatTabGroup, MatTab, MatTabContent, MatTabLabel, NgTemplateOutlet],
})
export class DetailsLayoutComponent {
  hasOverview = input(false);
  hasManage = input(false);
  hasConfig = input(false);
  hasHistory = input(false);
  historyTabLabel = input('History');
  selectedTabIndex = computed(() =>
    this.hasConfig() ? Number(this.hasOverview()) + Number(this.hasManage()) : 0,
  );
  changeTab = output<string>();
  topBar = contentChild<TemplateRef<unknown>>('topBar');
  manage = contentChild<TemplateRef<unknown>>('manage');
  configuration = contentChild<TemplateRef<unknown>>('configuration');
  overview = contentChild<TemplateRef<unknown>>('overview');
  orderHistory = contentChild<TemplateRef<unknown>>('orderHistory');
}
